<script lang="ts" setup>
import Button from 'primevue/button'

const { t } = useI18n()
const commerceStore = useCommerceStore()
const { selectedDiscount } = storeToRefs(commerceStore)

const discountsStore = useDiscountsStore()
const { discounts } = storeToRefs(discountsStore)

function selectDiscount(discount: any) {
  // Toggle: if already selected, deselect it
  if (selectedDiscount.value?.id === discount.id) {
    selectedDiscount.value = null
  }
  else {
    selectedDiscount.value = discount
  }
}

onMounted(async () => {
  await discountsStore.fetchDiscounts()
})
</script>

<template>
  <div v-if="discounts && discounts.length > 0">
    <h3 class="my-2 text-base">
      {{ t('Discounts') }}
    </h3>
    <div class="flex flex-col gap-2">
      <Button
        v-for="discount in discounts"
        :key="discount.id"
        :label="`${discount.percentage}%`"
        :severity="selectedDiscount?.id === discount.id ? 'info' : 'secondary'"
        class="text-base py-2"
        @click="selectDiscount(discount)"
      />
    </div>
  </div>
</template>
